import React from 'react'

import MobileIconButton from '../../../MobileIconButton/MobileIconButton'
import styles from './TransparentDrawerLayout.module.scss'

interface TransparentDrawerLayoutProps {
  closeDrawer: () => void
  title: string
  children: React.ReactNode
}

function TransparentDrawerLayout({
  closeDrawer,
  title,
  children
}: TransparentDrawerLayoutProps) {
  const handleCloseClick = () => {
    closeDrawer()
  }

  return (
    <div className={styles.layoutWrapper}>
      <div className={styles.layoutHeader}>
        <div className={styles.headerPlaceholder} />
        <p className={`body-bold-large ${styles.headerTitle}`}>{title}</p>
        <MobileIconButton
          iconName="las la-times icon-big"
          onClick={handleCloseClick}
          colorType="primary"
          variant="text"
        />
      </div>
      {children}
    </div>
  )
}

export default TransparentDrawerLayout
